import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Avatar, Dropdown, Typography } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useTracking } from '../hooks/useTracking';
import './PainelRepresentantes.css';
import bgCircularMilho from '../images/bg-circular-milho.png';

const { Text } = Typography;

const PainelRepresentantes = ({ user, onLogout }) => {
  const { trackEvent } = useTracking();
  const navigate = useNavigate();

  // const handleLojaClick = () => {
  //   trackEvent('click', 'Clicou no botão: Loja de Brindes');
  //   navigate('/home');
  // };

  const handleChamadosClick = () => {
    trackEvent('click', 'Clicou no botão: Abertura de Chamados');
    navigate('/chamados');
  };

  const handleMateriaisClick = () => {
    trackEvent('click', 'Clicou no botão: Materiais Institucionais (SharePoint)');
    window.open('https://sempreagrbr.sharepoint.com/sites/Marketing/Documentos%20Compartilhados/Forms/AllItems.aspx?FolderCTID=0x012000F3B7039D68C10A4DADAC7D683FCB5D4A&id=%2Fsites%2FMarketing%2FDocumentos%20Compartilhados%2FMateriais%20Institucionais%2FMATERIAIS%20INSTITUCIONAIS', '_blank');
  };

  const handleOutlookClick = () => {
    trackEvent('click', 'Clicou no botão: Outlook Web/App');
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isMobile) {
      const appUrl = 'ms-outlook://';
      const storeUrl = isIOS 
        ? 'https://apps.apple.com/app/microsoft-outlook/id951937596'
        : 'https://play.google.com/store/apps/details?id=com.microsoft.office.outlook';
      
      const link = document.createElement('a');
      link.href = appUrl;
      link.target = '_blank';
      
      const timeout = setTimeout(() => {
        window.open(storeUrl, '_blank');
      }, 2000);
      
      window.addEventListener('blur', () => {
        clearTimeout(timeout);
      });
      
      link.click();
    } else {
      window.open('https://outlook.office.com/mail/', '_blank');
    }
  };

  const handlePowerBIClick = () => {
    trackEvent('click', 'Clicou no botão: Power BI');
    window.open('https://bi.sempre.agr.br/', '_blank');
  };

  const handlePainelWebClick = () => {
    trackEvent('click', 'Clicou no botão: Painel de Pedidos');
    const userEmail = user?.email || 'usuario@exemplo.com';
    const url = `https://sempreagtech.dimo.com.br/#/auth/login?email=${encodeURIComponent(userEmail)}&token=dma9uX29ZGmvBKuSw7daR8SvTvsHgIAqQuwUxYrXsLbtuiv5BPouDuq8GtadWVkd3S03mFLZqRF2lkwcierW77wOu0DAsiix5xRID2YCGzvAAA84ryT1cuIBbUthcXoa1YzxzVMSrqK8rQbwbKUjXWGvSIBMeScKfzocJbYyMDJ78O3WWHGeAZQtXu0S1xK0buV1OX0v0ijJUxuADCVSVPvDhZuIwLCZe92LuXdl2EG9TOBSj41zAGfBHRhkkamLuABgMZqEF9O4ZA9k0PwqPujpo5SKzUKz3FBE4hD4RhJEbeke4jPfYCSFJKLSvOGebAJlRH3Xv2tq6gHDOHSEfyBkpZMxrBGRJ0extxMzB1BCsDVXsi`;
    window.open(url, '_blank');
  };

  const handleSeniorClick = () => {
    trackEvent('click', 'Clicou no botão: Painel de Gestão da Senior');
    window.open('https://platform.senior.com.br/login/?redirectTo=https%3A%2F%2Fplatform.senior.com.br%2Fsenior-x%2F&tenant=sempre.agr.br', '_blank');
  };

  const handleRastreioClick = () => {
    trackEvent('click', 'Clicou no botão: Rastreio de Cargas');
    window.open('https://tracking.azship.com.br/login', '_blank');
  };

  const handleParceiroFinanceiroClick = () => {
    trackEvent('click', 'Clicou no botão: Parceiro Financeiro');
    window.open('https://sempreagrbr.sharepoint.com/sites/ParceirosFinanceiros/Documentos%20Compartilhados/Forms/AllItems.aspx?id=%2Fsites%2FParceirosFinanceiros%2FDocumentos%20Compartilhados%2FParceiros%20Financeiros&viewid=066ad331%2D571f%2D4e8e%2D9274%2Ddf2f9cd72a04', '_blank');
  };

  const userMenuItems = [
    {
      key: 'email',
      label: (
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: '12px' }}>Olá,</Text>
          <Text strong>{user?.email}</Text>
        </Space>
      ),
      disabled: true
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      label: 'Sair',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: onLogout
    }
  ];

  return (
    <>
      {/* Header com Ant Design */}
      <header className="painel-header-modern">
        <div className="header-content">
          <div className="logo-section">
            <div className="logo-container">
              <img 
                src="/images/sempre-logo.png" 
                alt="Sempre Logo" 
                className="logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div className="logo-fallback" style={{display: 'none'}}>
                <h1 className="logo-text">SEMPRE</h1>
              </div>
            </div>
            <h2 className="painel-subtitle">Portal dos Franqueados</h2>
          </div>
          
          <div className="user-section">
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={['click']}>
              <Avatar 
                size={50} 
                icon={<UserOutlined />}
                className="user-avatar-clickable"
                style={{ 
                  background: 'linear-gradient(135deg, #024638 0%, #4a7c59 100%)',
                  cursor: 'pointer'
                }}
              />
            </Dropdown>
          </div>
        </div>
      </header>

      <div className="painel-modern-container">
        {/* Conteúdo principal */}
        <main className="painel-main">
          {/* Imagem de fundo circular com animação */}
          <div 
            className="painel-bg-image"
            style={{
              backgroundImage: `url(${bgCircularMilho})`
            }}
          ></div>
          <div className="welcome-section">
            <h1 className="welcome-title">Bem-vindo ao seu Portal</h1>
            <p className="welcome-subtitle">Acesse todas as ferramentas necessárias para seu trabalho</p>
          </div>

          <div className="tools-grid">
            {/* Card Loja - Destaque */}
            {/* <div className="tool-card tool-card-primary" onClick={handleLojaClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <path d="M16 10a4 4 0 0 1-8 0"></path>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Loja de Brindes</h3>
                <p className="card-description">Acesso produtos e faça pedidos</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div> */}

            {/* Card Chamados */}
            <div className="tool-card" onClick={handleChamadosClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Solicitações de Marketing</h3>
                <p className="card-description">Solicitações de Marketing e lançamento de notas e despesas</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Materiais */}
            <div className="tool-card" onClick={handleMateriaisClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10,9 9,9 8,9"></polyline>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Materiais Institucionais</h3>
                <p className="card-description">Documentos e recursos da empresa</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Outlook */}
            <div className="tool-card" onClick={handleOutlookClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Acesso ao E-mail Corporativo</h3>
                <p className="card-description">Caixa de entrada do e-mail</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Power BI */}
            <div className="tool-card" onClick={handlePowerBIClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 3v18h18"></path>
                  <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Acompanhamento de Vendas e Carteira de Pedidos</h3>
                <p className="card-description">Acesso a plataforma do Power BI</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Painel de Pedidos */}
            <div className="tool-card" onClick={handlePainelWebClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9,22 9,12 15,12 15,22"></polyline>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Painel Web (App)</h3>
                <p className="card-description">Acesso a clientes e pedidos</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Painel de Gestão da Senior */}
            <div className="tool-card" onClick={handleSeniorClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Painel de Gestão da Senior</h3>
                <p className="card-description">Acesso à plataforma Senior X</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Rastreio de Cargas */}
            <div className="tool-card" onClick={handleRastreioClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27,6.96 12,12.01 20.73,6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Rastreio de Cargas</h3>
                <p className="card-description">Acesso a plataforma da logística AZShip | Rastreamento</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>

            {/* Card Parceiro Financeiro */}
            <div className="tool-card" onClick={handleParceiroFinanceiroClick}>
              <div className="card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <div className="card-content">
                <h3 className="card-title">Parceiro Financeiro</h3>
                <p className="card-description">Documentos compartilhados dos Parceiros Financeiros</p>
              </div>
              <div className="card-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default PainelRepresentantes; 